import IconRefresh from "../icon/IconRefresh";
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer";

interface IconButtonRefreshProps extends IconButtonProps {
    spin?: boolean
}

export default function IconButtonRefresh(props: IconButtonRefreshProps) {
    return <IconButtonContainer {...props}>
        <IconRefresh spin={props.spin} />
    </IconButtonContainer>

}